import { FormSchemaDto } from "@amzn/crowd-front-end-common-library";

const addUserFormSchema: FormSchemaDto = {
  groups: [
    {
      groupLabel: "Add user",
      groupId: "general-group",
      fieldDefinitions: [
        {
          propertyName: "admins",
          label: "admins",
          propertyType: "multiselect<employee>",
          placeholder: "Search by employee name or alias",
          hidden: false,
        },
      ],
    },
  ],
};

export default addUserFormSchema;
